// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"93ba05e8","741":"2e233439","818":"2ed3120d","863":"fd9255f3"}[chunkId] + ".chunk.js";
};